import {Component, HostListener, OnInit} from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  scrolled: boolean = false;
  screen_width!: number;
  hide_small!: boolean;
  hide_medium!: boolean;
  hide_large!: boolean;

  constructor(
    public authService: AuthenticationService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.onResize();
  }

  signOut() {
    this.authService.signOut();
  }

  @HostListener("window:scroll", [])
  onScroll() {
    if (window.scrollY >= 80) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }
  }

  /**
   * Checks if the window size corresponds to one of the size limits
   *
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screen_width = window.innerWidth;
    this.hide_small = this.screen_width <= 576;
    this.hide_medium = this.screen_width <= 750;
    this.hide_large = this.screen_width <= 991;
  }
}
